import { useI18n } from '@i18n';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { ICONS } from '@/assets/icons';
import { getShortcutLabel } from '@/components/global-search/utils';
import Iconify from '@/components/Iconify';
import { ICON_SIZE_MAP, NAVBAR } from '@/config';

type Props = {
  onClick: () => void;
  isCollapse: boolean;
};

export default function GlobalSearchButton({ onClick, isCollapse }: Props) {
  const { t } = useI18n();
  return (
    <Button
      variant="text"
      startIcon={<Iconify icon={ICONS.SEARCH} width={ICON_SIZE_MAP.xl} height={ICON_SIZE_MAP.md} sx={{ ml: 0.5 }} />}
      onClick={onClick}
      sx={{
        textTransform: 'none',
        width: `calc(${NAVBAR.DASHBOARD_WIDTH}px - 8px)`,
        height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
        mx: 0.5,
        mb: 0.5,
        px: 2,
        justifyContent: 'flex-start',
        color: 'text.secondary',
        '& .MuiButton-endIcon': { ml: 'auto' },
      }}
      endIcon={
        isCollapse ? null : (
          <Box
            sx={{
              bgcolor: 'action.hover',
              px: 1,
              borderRadius: 1,
              fontSize: '14px !important',
              fontWeight: 500,
              color: 'text.secondary',
            }}
          >
            {getShortcutLabel()}
          </Box>
        )
      }
      disableRipple
    >
      {isCollapse ? '' : t('GlobalSearch_SearchPredium')}
    </Button>
  );
}
